import React from 'react';
import { Modal } from 'antd';
import dynamic from 'next/dynamic';

const ModelViewer = dynamic(
  () => import('../my-stuff/upload-asset/ModelViewer'),
  {
    loading: () => <p>Loading...</p>,
    ssr: false,
  }
);

export default function ModelViewerModal({ open, setOpen, modelUrl }) {
  return (
    <Modal
      open={open}
      zIndex={1400}
      footer={false}
      onCancel={() => setOpen(false)}
      title={'Model 3D preview'}
    >
      <ModelViewer src={modelUrl} height={500} />
    </Modal>
  );
}
